import React from 'react'
import useSystemSettings from '../../../hooks/use-system-settings'
import PaginatedList from '../../screen-templates/paginated-list'
import SystemSetting from '../system-setting'

const Container = ({ children }) => (<div>{children}</div>)

const SystemSettingsList = () => {

    const { systemSettings, isLoading } = useSystemSettings()

    return (
        <PaginatedList
            items = {systemSettings}
            pageSize={10}
            itemComponent={SystemSetting}
            total={systemSettings.length}
            offset={0}
            loading={isLoading}
            containerComponent={React.Fragment}
        />
    )
}

export default SystemSettingsList